// import React, { lazy } from 'react';
// import React from 'react';
// import React, { Suspense, lazy } from 'react'; // Removed unused React import
// import { Suspense, lazy } from 'react';
// import LoadingFallback from '../components/common/LoadingFallback'; // Assuming correct path
import { lazy } from 'react';
// Removed unused imports
// import { Box, CircularProgress } from '@mui/material';

/**
 * Utility for lazy loading component groups
 * 
 * This function helps to create lazy-loaded components with standardized
 * dynamic imports and chunk naming for better organization in the bundle.
 * 
 * @param {string} componentPath - Path to the component file
 * @param {string} [chunkName] - Optional webpack chunk name
 * @returns {React.LazyExoticComponent} Lazy-loaded component
 * 
 * @example
 * // Create a lazy-loaded component with automatic chunk naming
 * const LazyHomePage = lazyLoad('./pages/HomePage');
 * 
 * @example
 * // Create a lazy-loaded component with custom chunk name
 * const LazySettingsPage = lazyLoad('./pages/SettingsPage', 'settings');
 */
export const lazyLoad = (componentPath, chunkName) => {
  return lazy(() => {
    const promise = import(
      /* webpackChunkName: `${chunkName || "lazy"}` */

      `../${componentPath}`
    );
    
    // Add a small delay when in development mode to simulate slower networks
    if (process.env.NODE_ENV === 'development') {
      return new Promise(resolve => {
        setTimeout(() => resolve(promise), 800);
      });
    }
    
    return promise;
  });
};

export default lazyLoad; 